import {createColumnHelper} from "@tanstack/react-table";
import CrudActions from "components/crud/CrudActions";


const columnHelper = createColumnHelper();

/*
|--------------------------------------------------------------------------
| DATE
|--------------------------------------------------------------------------
*/

const formatDate = (value) => {

    if (!value) {
        return "-";
    }

    const date =
        new Date(value);

    if (
        Number.isNaN(
            date.getTime()
        )
    ) {
        return "-";
    }

    return date.toLocaleDateString(
        "en-IN",
        {
            day: "2-digit",
            month: "short",
            year: "numeric",
        }
    );
};


/*
|--------------------------------------------------------------------------
| STATUS
|--------------------------------------------------------------------------
*/

const getStatusClass = (
    status
) => {

    switch (status) {

        case "draft":
            return (
                "bg-gray-50 " +
                "text-gray-700 " +
                "border-gray-200"
            );

        case "submitted":
            return (
                "bg-blue-50 " +
                "text-blue-700 " +
                "border-blue-200"
            );

        case "approved":
            return (
                "bg-green-50 " +
                "text-green-700 " +
                "border-green-200"
            );

        case "rejected":
            return (
                "bg-red-50 " +
                "text-red-700 " +
                "border-red-200"
            );

        case "cancelled":
            return (
                "bg-orange-50 " +
                "text-orange-700 " +
                "border-orange-200"
            );

        default:
            return (
                "bg-gray-50 " +
                "text-gray-700 " +
                "border-gray-200"
            );
    }
};


/*
|--------------------------------------------------------------------------
| SCHOOL LOCATION HELPERS
|--------------------------------------------------------------------------
*/

const getLocation = (
    school
) => {

    const location =
        school?.location || {};

    return {

        city:
            location?.city?.name ||
            school?.city?.name ||
            "-",

        district:
            location?.district?.name ||
            school?.district?.name ||
            "-",

        state:
            location?.state?.name ||
            school?.state?.name ||
            "-",

        area:
            location?.area?.name ||
            school?.area?.name ||
            "-",

        beat:
            location?.beat?.name ||
            school?.beat?.name ||
            "",

        zone:
            location?.zone?.name ||
            school?.zone?.name ||
            "",
    };
};


const getBeatZone = (
    school
) => {

    const location =
        getLocation(school);

    if (location.beat) {
        return location.beat;
    }

    if (location.zone) {
        return location.zone;
    }

    return "";
};


/*
|--------------------------------------------------------------------------
| VISIT LOCATION
|--------------------------------------------------------------------------
*/

const renderSchoolVisit = (
    visit
) => {

     console.log("Journey Plan Visit Data:", visit);
  console.log("Claim Amount:", visit?.claimAmount);

    const school =
        visit?.school;

    if (!school) {

        return (
            <div
                className="
                    rounded-lg
                    border
                    border-gray-200
                    bg-gray-50
                    px-3
                    py-2
                "
            >

                <div
                    className="
                        text-xs
                        font-medium
                        text-gray-500
                    "
                >
                    {visit?.itemType === "party"
                        ? "Party Visit"
                        : "School Visit"
                    }
                </div>

                {visit?.party?.name && (
                    <div
                        className="
                            mt-1
                            text-sm
                            font-semibold
                            text-gray-800
                        "
                    >
                        {visit.party.name}
                    </div>
                )}

                {!visit?.party?.name && (
                    <div
                        className="
                            mt-1
                            text-sm
                            text-gray-500
                        "
                    >
                        Visit location not available
                    </div>
                )}

            </div>
        );
    }


    const location =
        getLocation(school);

    const beatZone =
        getBeatZone(school);


    return (
        <div
            className="
                rounded-lg
                border
                border-gray-200
                bg-white
                px-3
                py-2.5
            "
        >

            {/* =================================================
                SCHOOL NAME
            ================================================= */}

            <div
                className="
                    text-sm
                    font-semibold
                    text-gray-900
                "
            >
                {school.name || "-"}
            </div>


            {/* =================================================
                CITY
            ================================================= */}

            <div
                className="
                    mt-1
                    text-xs
                    text-gray-600
                "
            >
                <span
                    className="
                        font-medium
                        text-gray-700
                    "
                >
                    City / Town:
                </span>{" "}

                {location.city}
            </div>


            {/* =================================================
                DISTRICT
            ================================================= */}

            <div
                className="
                    text-xs
                    text-gray-600
                "
            >
                <span
                    className="
                        font-medium
                        text-gray-700
                    "
                >
                    District:
                </span>{" "}

                {location.district}
            </div>


            {/* =================================================
                STATE
            ================================================= */}

            <div
                className="
                    text-xs
                    text-gray-600
                "
            >
                <span
                    className="
                        font-medium
                        text-gray-700
                    "
                >
                    State:
                </span>{" "}

                {location.state}
            </div>


            {/* =================================================
                AREA / LOCALITY
            ================================================= */}

            <div
                className="
                    text-xs
                    text-gray-600
                "
            >
                <span
                    className="
                        font-medium
                        text-gray-700
                    "
                >
                    Area / Locality:
                </span>{" "}

                {location.area}
            </div>


            {/* =================================================
                BEAT / ZONE
            ================================================= */}

            {beatZone && (
                <div
                    className="
                        text-xs
                        text-gray-600
                    "
                >
                    <span
                        className="
                            font-medium
                            text-gray-700
                        "
                    >
                        Beat / Zone:
                    </span>{" "}

                    {beatZone}
                </div>
            )}


            {/* =================================================
                VISIT DETAILS
            ================================================= */}

            {(visit?.plannedTime ||
                visit?.purpose) && (

                <div
                    className="
                        mt-2
                        border-t
                        border-gray-100
                        pt-2
                    "
                >

                    {visit?.plannedTime && (
                        <div
                            className="
                                text-xs
                                text-gray-500
                            "
                        >
                            <span
                                className="
                                    font-medium
                                    text-gray-700
                                "
                            >
                                Planned Time:
                            </span>{" "}

                            {visit.plannedTime}
                        </div>
                    )}

                    {visit?.purpose && (
                        <div
                            className="
                                text-xs
                                text-gray-500
                            "
                        >
                            <span
                                className="
                                    font-medium
                                    text-gray-700
                                "
                            >
                                Purpose:
                            </span>{" "}

                            {visit.purpose}
                        </div>
                    )}

<div className="mt-2 flex items-center gap-2 border-t border-gray-100 pt-2">
  <span className="text-xs font-medium text-gray-600">
    Claim Amount:
  </span>

  <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-sm font-bold text-green-700">
    ₹{Number(visit?.claimAmount ?? 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}
  </span>
</div>

                </div>
            )}

        </div>
    );
};


/*
|--------------------------------------------------------------------------
| COLUMNS
|--------------------------------------------------------------------------
*/

export const journeyPlanColumns = ({
    onEdit,
    onDelete,
    onSubmit,
    onApprove,
    onReject,
    onView,
} = {}) => {

    /*
    |--------------------------------------------------------------------------
    | USER
    |--------------------------------------------------------------------------
    */

    let user = {};

    try {

        user = JSON.parse(
            localStorage.getItem(
                "user"
            ) || "{}"
        );

    } catch (error) {

        console.error(
            "Unable to parse logged-in user",
            error
        );

    }


    const permissions =
        Array.isArray(
            user?.permissions
        )
            ? user.permissions
            : [];


    const roles =
        Array.isArray(
            user?.roles
        )
            ? user.roles
            : [];


    /*
    |--------------------------------------------------------------------------
    | PERMISSION HELPERS
    |--------------------------------------------------------------------------
    */

    const hasPermission = (
        permission
    ) => {

        return permissions.includes(
            permission
        );

    };


    /*
    |--------------------------------------------------------------------------
    | ROLES
    |--------------------------------------------------------------------------
    */

    const isAdmin =
        roles.includes(
            "admin"
        ) ||
        roles.includes(
            "super_admin"
        );


    const isManager =
        roles.includes(
            "manager"
        ) ||
        roles.includes(
            "team_leader"
        ) ||
        roles.includes(
            "regional_manager"
        );


    /*
    |--------------------------------------------------------------------------
    | EDIT
    |--------------------------------------------------------------------------
    */

    const canEdit =
        hasPermission(
            "journey.update"
        ) ||
        hasPermission(
            "journey.manage"
        );


    /*
    |--------------------------------------------------------------------------
    | DELETE
    |--------------------------------------------------------------------------
    */

    const canDelete =
        hasPermission(
            "journey.delete"
        ) ||
        hasPermission(
            "journey.manage"
        );


    /*
    |--------------------------------------------------------------------------
    | APPROVE / REJECT
    |--------------------------------------------------------------------------
    */

    const canApprove =
        (
            isAdmin ||
            isManager
        ) &&
        (
            hasPermission(
                "journey.approve"
            ) ||
            hasPermission(
                "journey.manage"
            )
        );


    return [

        /*
        |--------------------------------------------------------------------------
        | DATE
        |--------------------------------------------------------------------------
        */

        columnHelper.accessor(
            "planDate",
            {

                id: "planDate",

                header: "Date",

                cell: (info) => (

                    <span>
                        {
                            formatDate(
                                info.getValue()
                            )
                        }
                    </span>

                ),
            }
        ),


        /*
        |--------------------------------------------------------------------------
        | EMPLOYEE
        |--------------------------------------------------------------------------
        */

        columnHelper.accessor(
            "employee.name",
            {

                id: "employee",

                header: "Employee",

                cell: (info) => {

                    const item =
                        info.row.original;

                    return (

                        <div>

                            <div
                                className="
                                    font-semibold
                                    text-gray-700
                                "
                            >
                                {
                                    info.getValue() ||
                                    "-"
                                }
                            </div>

                            {
                                item?.employee?.employeeCode && (

                                    <div
                                        className="
                                            text-xs
                                            text-gray-500
                                        "
                                    >
                                        {
                                            item.employee.employeeCode
                                        }
                                    </div>

                                )
                            }

                        </div>

                    );
                },
            }
        ),


        /*
        |--------------------------------------------------------------------------
        | TITLE
        |--------------------------------------------------------------------------
        */

        columnHelper.accessor(
            "title",
            {

                id: "title",

                header: "Title",

                cell: (info) => (

                    <span>
                        {
                            info.getValue() ||
                            "-"
                        }
                    </span>

                ),
            }
        ),


        /*
        |--------------------------------------------------------------------------
        | SCHEDULED VISITS
        |--------------------------------------------------------------------------
        */

        columnHelper.accessor(
            "items",
            {

                id: "items",

                header: "Scheduled Visits",

                cell: (info) => {

                    const visits =
                        info.getValue() || [];

                    if (!visits.length) {

                        return (
                            <span
                                className="
                                    text-sm
                                    text-gray-400
                                "
                            >
                                No visits
                            </span>
                        );
                    }


                    return (

                        <div
                            className="
                                w-[460px]
                                max-w-[460px]
                                space-y-2
                            "
                        >

                            {visits.map(
                                (
                                    visit,
                                    index
                                ) => (

                                    <div
                                        key={
                                            visit?.id ||
                                            `${index}-${visit?.school?.id || "visit"}`
                                        }
                                        className="
                                            relative
                                            pl-7
                                        "
                                    >

                                        {/* Sequence */}

                                        <div
                                            className="
                                                absolute
                                                left-0
                                                top-2
                                                flex
                                                h-5
                                                w-5
                                                items-center
                                                justify-center
                                                rounded-full
                                                bg-blue-50
                                                text-[10px]
                                                font-bold
                                                text-blue-700
                                            "
                                        >
                                            {
                                                visit?.sequence ||
                                                index + 1
                                            }
                                        </div>


                                        {renderSchoolVisit(
                                            visit
                                        )}

                                    </div>

                                )
                            )}

                        </div>

                    );
                },
            }
        ),


        /*
        |--------------------------------------------------------------------------
        | VISIT COUNT
        |--------------------------------------------------------------------------
        */

        columnHelper.display({

            id: "visitCount",

            header: "Visits",

            cell: ({ row }) => {

                const count =
                    row.original?.items?.length ||
                    0;

                return (

                    <span
                        className="
                            inline-flex
                            min-w-[32px]
                            justify-center
                            rounded-full
                            border
                            border-blue-200
                            bg-blue-50
                            px-2.5
                            py-1
                            text-xs
                            font-semibold
                            text-blue-700
                        "
                    >
                        {count}
                    </span>

                );

            },
        }),


        /*
        |--------------------------------------------------------------------------
        | STATUS
        |--------------------------------------------------------------------------
        */

        columnHelper.accessor(
            "status",
            {

                id: "status",

                header: "Status",

                cell: (info) => {

                    const status =
                        info.getValue();

                    return (

                        <span
                            className={`
                                inline-flex
                                rounded-full
                                border
                                px-3
                                py-1
                                text-xs
                                font-semibold
                                capitalize
                                ${getStatusClass(
                                    status
                                )}
                            `}
                        >
                            {
                                status
                                    ? String(
                                        status
                                    ).replace(
                                        /_/g,
                                        " "
                                    )
                                    : "-"
                            }
                        </span>

                    );
                },
            }
        ),


        /*
        |--------------------------------------------------------------------------
        | ACTIONS
        |--------------------------------------------------------------------------
        */

        columnHelper.display({

            id: "actions",

            header: "Actions",

            cell: ({ row }) => {

                const data =
                    row.original;

                const status =
                    data?.status;


                /*
                |--------------------------------------------------------------------------
                | EDIT
                |--------------------------------------------------------------------------
                */

                const canEditRow =
                    canEdit &&
                    status ===
                        "draft";


                /*
                |--------------------------------------------------------------------------
                | DELETE
                |--------------------------------------------------------------------------
                */

                const canDeleteRow =
                    canDelete &&
                    status ===
                        "draft";


                /*
                |--------------------------------------------------------------------------
                | SUBMIT
                |--------------------------------------------------------------------------
                */

                const canSubmitRow =
                    status ===
                        "draft" &&
                    typeof onSubmit ===
                        "function";


                /*
                |--------------------------------------------------------------------------
                | APPROVE / REJECT
                |--------------------------------------------------------------------------
                */

                const canReviewRow =
                    canApprove &&
                    status ===
                        "submitted";


                return (

                    <div
                        className="
                            flex
                            items-center
                            gap-2
                            whitespace-nowrap
                        "
                    >

                        <CrudActions

                            /*
                            |--------------------------------------------------------------------------
                            | VIEW
                            |--------------------------------------------------------------------------
                            */

                            showView={
                                Boolean(
                                    onView
                                )
                            }

                            onView={
                                onView
                                    ? () =>
                                        onView(
                                            data
                                        )
                                    : undefined
                            }

                            viewTitle="View Journey Plan"


                            /*
                            |--------------------------------------------------------------------------
                            | EDIT
                            |--------------------------------------------------------------------------
                            */

                            showEdit={
                                canEditRow
                            }

                            onEdit={
                                canEditRow &&
                                typeof onEdit ===
                                    "function"
                                    ? () =>
                                        onEdit(
                                            data
                                        )
                                    : undefined
                            }

                            editTitle="Edit Journey Plan"


                            /*
                            |--------------------------------------------------------------------------
                            | APPROVE
                            |--------------------------------------------------------------------------
                            */

                            showApprove={
                                canReviewRow
                            }

                            onApprove={
                                canReviewRow &&
                                typeof onApprove ===
                                    "function"
                                    ? () =>
                                        onApprove(
                                            data.id
                                        )
                                    : undefined
                            }

                            approveTitle="Approve Journey Plan"


                            /*
                            |--------------------------------------------------------------------------
                            | REJECT
                            |--------------------------------------------------------------------------
                            */

                            showReject={
                                canReviewRow
                            }

                            onReject={
                                canReviewRow &&
                                typeof onReject ===
                                    "function"
                                    ? () =>
                                        onReject(
                                            data.id
                                        )
                                    : undefined
                            }

                            rejectTitle="Reject Journey Plan"


                            /*
                            |--------------------------------------------------------------------------
                            | DELETE
                            |--------------------------------------------------------------------------
                            */

                            showDelete={
                                canDeleteRow
                            }

                            onDelete={
                                canDeleteRow &&
                                typeof onDelete ===
                                    "function"
                                    ? () =>
                                        onDelete(
                                            data.id
                                        )
                                    : undefined
                            }

                            deleteTitle="Delete Journey Plan"

                        />


                        {/* =================================================
                            SUBMIT
                        ================================================= */}

                        {
                            canSubmitRow && (

                                <button
                                    type="button"

                                    onClick={() =>
                                        onSubmit(
                                            data.id
                                        )
                                    }

                                    title="Submit Journey Plan"

                                    aria-label="Submit Journey Plan"

                                    className="
                                        inline-flex
                                        h-9
                                        w-9
                                        items-center
                                        justify-center
                                        rounded-lg
                                        border
                                        border-indigo-200
                                        bg-indigo-50
                                        text-indigo-600
                                        transition-all
                                        duration-150
                                        hover:border-indigo-300
                                        hover:bg-indigo-100
                                        hover:text-indigo-700
                                        focus:outline-none
                                        focus:ring-2
                                        focus:ring-indigo-200
                                    "
                                >

                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        className="h-4 w-4"
                                    >

                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="
                                                M4 12h15
                                                m0 0l-6-6
                                                m6 6l-6 6
                                            "
                                        />

                                    </svg>

                                </button>

                            )
                        }

                    </div>

                );
            },
        }),

    ];
};
